import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, zip} from 'rxjs';
import {ActiviteitPageRequest} from './activiteit-page-request';
import {Activiteit, ActiviteitDto} from './activiteit';
import {ActiviteitPage} from './activiteit-page';
import {ClientService} from '../client/client.service';
import {PageDto} from '../core/pagination/page';
import {map, mergeMap} from 'rxjs/operators';
import {UserService} from '../core/auth/user.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActiviteitService {
  private http = inject(HttpClient);
  private clientService = inject(ClientService);
  private userService = inject(UserService);

  getActiviteiten$(pageRequest: ActiviteitPageRequest): Observable<ActiviteitPage> {
    return this.http
      .post<PageDto<ActiviteitDto>>(`${environment.apiUrl}/activiteiten/page`, pageRequest)
      .pipe(mergeMap(pageDto =>
        zip(
          this.clientService.getClientenByIds$(pageDto.items.map(item => item.clientId)),
          this.userService.getUsersByIds$(pageDto.items.map(item => ({
            id: item.auteurId,
            nummer: item.auteurNummer,
            role: item.auteurRol
          })))
        ).pipe(
          map(([clienten, auteurs]) => new ActiviteitPage(
            pageRequest.verwerkingsStatus,
            pageDto.ascending,
            pageDto.pageSize,
            pageDto.pageNumber,
            pageDto.lastPage,
            pageDto.items.map(dto => Activiteit.deserialize(dto)),
            clienten,
            auteurs
          )))
      ));
  }

  verwerkActiviteit$(id: string): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/activiteiten/${id}/verwerk`, {});
  }
}
